import React from "react";
import { Modal } from "react-bootstrap";
import useTranslator from "../../hooks/useTranslator";
import Cancelimg from "../../assets/img/cancel-01.svg";

const InsuranceReviewModal = ({ show, onHide, onGotIt }) => {
  const { _t } = useTranslator();

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="newmodalui wrapper-modal insuranceReviewModal"
    >
      <Modal.Header>
        <div className="cursor-pointer ms-auto" onClick={onHide}>
          <img src={Cancelimg} alt="close" className="canceicon" />
        </div>
      </Modal.Header>
      <Modal.Body className="text-center">
        <div className="review-icon-container ">
          <img
            src="/images/clock-icon.svg"
            alt="clock"
            className="review-clock-icon"
          />
        </div>
        <h2 className="review-modal-title ">
          {_t("purchaseInsuranceReviewRequestPopupTitle")}
        </h2>
        <p className="review-modal-text ">
          {_t("purchaseInsuranceReviewRequestPopupDescription")}
        </p>
        <div className="d-flex justify-content-center">
          <button className="btnNext got-it-btn" onClick={onGotIt}>
            {_t("gotIt")}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default InsuranceReviewModal;
